import { Component, OnInit } from '@angular/core';
import {FieldValueService} from '../../services/field-value/field-value.service';
import {FieldComponentAbstract} from '../abstracts/FieldComponentAbstract';

@Component({
  selector: 'app-default-readonly-field',
  templateUrl: './default-readonly-field.component.html',
  styleUrls: ['./default-readonly-field.component.scss']
})
export class DefaultReadonlyFieldComponent extends FieldComponentAbstract implements OnInit {

  public $value: Promise<string>;

  constructor(private fieldReadonlyService: FieldValueService) {
    super();
  }

  ngOnInit() {
    this.$value = this.fieldReadonlyService.getFieldValue(this.fieldValue);
  }

}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/fields/components/default-readonly-field/default-readonly-field.component.ts